import { Component, Shark } from "shark-mvc";
import Tagify from "@yaireo/tagify";
import { NousCore } from "nouscore-js-api";
import Volume from "../../models/Volume";

import templateContent from "./reference-volumes-card.html";

import volumeManager from "../../controllers/VolumeManager";

class ReferenceVolumesComponent extends Component {
	constructor () {
		super("referenceVolumesComponent");

		this.addTemplate("", templateContent);
	}

	beforeLoad () {
		this.refreshreferenceVolumeList();
	}

	async refreshreferenceVolumeList () {
		const referencevolumeListResult = await volumeManager.getList();
		const referencevolumeList = Shark.getInstanceList(Volume, referencevolumeListResult.data);

		referencevolumeList.sort((a, b) => {
			return a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1;
		});
		
		console.log({referencevolumeList});
		Shark.set({
			referencevolumeList,
		});
	}

	init () {
		Shark.set({
			referencevolumeList: [],
		});
	}

	setup (event, data) {
		console.log("mainNavComponent_contentLoadedHandler", {event, data});

		const tagContainer = document.querySelector("#referenceVolumesComponentTagsField");
		
		console.log("88888888888 tagContainer", tagContainer);
		if (tagContainer) {
			this.tagify = new Tagify(tagContainer, {autoComplete: { rightKey: true} });//, {whitelist:[]}
			this.tagify.on("add", this.onAdd);
			this.tagify.on("input", this.onInput);
			return true;
		}
		else {
			return false;
		}
	}

	onAdd (event) {
		console.log(event);
		const tag = event.detail.data.value;
		const { currContent, referencevolumeList } = Shark.get();

		if (currContent) {
			const volume = referencevolumeList.find(item => tag === `${item.number.toString().padStart(2, "0")} ${item.title}`);
			
			if (volume) {
				console.log({volume});
				
				currContent.set({
					referenceVolumeGuids: [volume.guid],
				});
			}
		}
	}

	onInput (e) {
		var value = e.detail.value;
		if (value.trim() !== "") {
			referenceVolumesComponent.tagify.whitelist = null; // reset the whitelist

			// https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort
			referenceVolumesComponent.controller && referenceVolumesComponent.controller.abort();
			referenceVolumesComponent.controller = new AbortController();

			// show loading animation and hide the suggestions dropdown
			referenceVolumesComponent.tagify.loading(true).dropdown.hide();

			const rd = NousCore.api.createRequest({ item: { searchKey: value } });

			const request = {
				payload: rd,
				__nctoken__: localStorage["NousCore.api.last_token"],
				__ukey__: "",
			};

			let targetApiEndPoint = "";

			switch (Shark.activePage.id) {
				case "imageContentView":
					targetApiEndPoint = "image-content";
					break;
				case "placeContentView":
					targetApiEndPoint = "place-content";
					break;
				default:
					targetApiEndPoint = "text-content";
					break;
			}

			// fetch(`https://wscontenutidigitali.lineacontinua.net/api/${targetApiEndPoint}/search-reference-volume`, {
			fetch(`${Shark.$store.apiURL}/${targetApiEndPoint}/search-reference-volume`, {
				body: JSON.stringify(request),
				method: "POST",
				signal: referenceVolumesComponent.controller.signal,
			})
			.then(RES => RES.json())
			.then(function(data){
				const newWhitelist = data.payload.items.map(item => JSON.parse(item.referenceVolumes)?.[0]);
				
				console.log({data, newWhitelist});

				referenceVolumesComponent.tagify.whitelist = newWhitelist; // update whitelist Array in-place
				referenceVolumesComponent.tagify.loading(false).dropdown.show(value); // render the suggestions dropdown
			});
		}
	}
}

const referenceVolumesComponent = new ReferenceVolumesComponent();

Shark.registerComponent(referenceVolumesComponent);

export default referenceVolumesComponent;
